import { render, staticRenderFns } from "./SelectorTagsArtistas.vue?vue&type=template&id=7dda4531&scoped=true&"
import script from "./SelectorTagsArtistas.vue?vue&type=script&lang=js&"
export * from "./SelectorTagsArtistas.vue?vue&type=script&lang=js&"
import style0 from "./SelectorTagsArtistas.vue?vue&type=style&index=0&id=7dda4531&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dda4531",
  null
  
)

export default component.exports